import Middleware from './middleware';

export default () => {
  Middleware.admin = ({ app, softRedirect }) => {
    if (!app.$auth.isAdmin) {
      return softRedirect(app.localePath('index'));
    }
  };
};
